module.exports = __webpack_public_path__ + "img/deliverytime.6d9155c.webp";